import { ExportCostApproachRollupRow } from '../ExportCostApproachRollupRow.tsx';

type Props = {
  data: {
    label: string;
    value: string | null;
  };
  bold?: boolean;
};

export function ManufacturedCostApproachTableRow(props: Props) {
  return (
    <ExportCostApproachRollupRow
      label={props.data.label}
      value={props.data.value ?? ''}
      isBold={props.bold || false}
      showEquals={false}
    />
  );
}
